<template>
  <div class="orderPage">
    <div class="data_wrap flex-between" @click="handleShowDate">
      <div class="left flex-rowl">
        <i class="iconfont icon-rili"></i> {{ params.datestr }}
      </div>
      <div class="right"><i class="iconfont icon-toTop"></i></div>
    </div>
    <div class="select_wrap flex-between">
      <div class="left flex-rowl">
        <i class="iconfont icon-navicon-ctgl"></i>
        <van-dropdown-menu>
          <van-dropdown-item
            title-class="所有区域"
            v-model="areaText"
            :options="areaOpation"
          />
        </van-dropdown-menu>
      </div>
      <div class="right"><i class="iconfont icon-toTop"></i></div>
    </div>
    <div class="order_num">订单总数：{{ total }}</div>
    <div class="select_wrap flex-between">
      <div class="left flex-rowl">
        <i class="iconfont icon-navicon-ctgl"></i>
        <van-dropdown-menu>
          <van-dropdown-item
            title-class="所有区域"
            v-model="params.parameterid"
            :options="orderParameter"
            @change="changeParameter"
          />
        </van-dropdown-menu>
      </div>
      <div class="right"><i class="iconfont icon-toTop"></i></div>
    </div>

    <div class="order_wrap">
      <div class="list" v-if="dataList.length > 0">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <div class="title">{{ item.area_name }}：{{ item.ordernum }}单</div>
          <!-- 餐厅列表 -->
          <div class="restaurant_list">
            <div class="restaurant_item flex-rowl"  v-for="(itemChild, indexChild) in item.shops" :key="indexChild">
              <p>{{itemChild.shop_name}}：{{itemChild.totalnum}}单</p>
              <p>取餐状态：{{itemChild.getnum}}/{{ itemChild.totalnum }}</p>
            </div>
          </div>
        </div>
      </div>

      <van-empty description="暂无数据" v-else />
    </div>

    <!-- 详情弹窗 -->
    <van-popup v-model="isShow" position="bottom"
      ><van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @cancel="cancelDate"
        @confirm="confirmDate"
    /></van-popup>
  </div>
</template>
  
  <script>
import {
  getToken,
  getParameterOrderList,
  encryptstringadd,
  getOrderParameter,
} from "../../api/api";
export default {
  name: "subzoneDataList",
  data() {
    return {
      isShowPopupTextarea: false,
      isShowPopup: false,
      popupType: 1,

      orserState: "所有状态订单",
      orderProperty: "所有情况订单",

      isShow: false,
      areaOpation: [{ value: "", text: "深圳龙华园区" }],
      areaText: "",
      orderParameter: [
        {
          value: "",
          text: "所有区域",
        },
      ], // 区域
      params: {
        token: "",
        datestr: "",
        parameterid: "",
      },
      sitetype: "",

      isLoading: true,
      total: 0,
      dataList: [],
      currentDate: new Date(),
    };
  },
  created() {
    let newData = new Date();
    this.params.datestr =
      newData.getFullYear() +
      "/" +
      (newData.getMonth() + 1).toString().padStart(2, "0") +
      "/" +
      newData.getDate().toString().padStart(2, "0");

    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;

    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderParameter(res.data.token);
          this.getParameterOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 调用门店列表
    getParameterOrderList() {
      let { params } = this;
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      getParameterOrderList(params).then((res) => {
        if (res.error_code == 0) {
          let neweRes = res.data;
          console.log(neweRes, "=======-");

          this.total = neweRes.totalnum;
          this.dataList = neweRes.list;
          this.isLoading = false;
        } else {
          this.total = 0;
          this.dataList = [];
        }
        toast.clear();
      });
    },

    // 获取区域
    getOrderParameter(token) {
      getOrderParameter({ token }).then((res) => {
        if (res.error_code == 0) {
          let newArr = res.data.map((item) => ({
            value: item.id,
            text: item.area_name,
          }));

          this.orderParameter = this.orderParameter.concat(...newArr);
        }
      });
    },

    changeParameter(e) {
      this.params.parameterid = e;
      this.getParameterOrderList();
    },

    // 显示时间选择
    handleShowDate() {
      this.isShow = true;
      // this.getParameterOrderList();
    },
    cancelDate() {
      this.isShow = false;
    },
    confirmDate(e) {
      this.params.datestr =
        e.getFullYear() +
        "/" +
        (e.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        e.getDate().toString().padStart(2, "0");
      this.getParameterOrderList();
      this.cancelDate();
    },

    // 跳转详情
    handleDetail(type, item, itemChild) {
      let { datestr } = this.params;
      if (type == 1) {
        let data = {
          datestr,
          shop_name: item.shop_name,
        };
        this.encryptstringadd("orderDataList", { data });
      } else if (type == 2) {
        let data = {
          datestr,
          shop_name: item.shop_name,
          parametername: itemChild.parametername,
          buildingname: itemChild.buildingname,
          address_detail: itemChild.address_detail,
          buildingid: itemChild.buildingid,
          parameterid: itemChild.parameterid,
          totalnum: itemChild.totalnum,
          getnum: itemChild.getnum,
        };
        this.encryptstringadd("orderDataDetail", { data });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.userInfo.openid,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$router.push(`/${name}/${response.encryptstring}`);
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
  <style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .select_wrap {
    width: 660px;
    margin: auto;
    box-sizing: border-box;
    background: #fff;
    font-size: 30px;
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    .icon-navicon-ctgl {
      font-size: 30px;
    }
    .left {
      flex: 1;
    }
    /deep/ .van-dropdown-menu {
      // flex: 1;
      flex-shrink: 0;
      width: 100%;
    }
    /deep/ .van-dropdown-menu__item {
      padding: 0;
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 100%;
      box-sizing: border-box;
      text-align: left;
    }
    /deep/ .van-dropdown-menu__title::after {
      // right: 20px;
      border-color: transparent;
    }
    .search_btn {
      flex-shrink: 0;
      width: 160px;
      font-size: 24px;
      background: #096f70;
      color: #fff;
      margin-left: 10px;
      white-space: nowrap;
      height: 90px;
      .iconfont {
        font-size: 28px;
        margin-left: 5px;
      }
    }
  }
  .data_wrap {
    width: 660px;
    margin: auto;
    height: 90px;
    background: #fff;
    font-size: 30px;
    padding: 0 30px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .icon-rili {
      font-size: 28px;
      margin-right: 15px;
    }
  }
  .icon-toTop {
    transform: rotate(-180deg);
    display: inline-block;
    font-size: 26px;
  }
  .order_num {
    width: 660px;
    margin: 30px auto;
    font-size: 24px;
    color: #096f70;
  }
  .order_wrap {
    margin-top: 25px;
    height: 61vh;
    overflow-y: scroll;
    padding-bottom: 100px;
    box-sizing: border-box;
    // 滚动条隐藏
    &::-webkit-scrollbar {
      display: none;
    }
    .list {
      .item {
        width: 700px;
        margin: 0 auto 30px;
        .title {
          background: #ffffff;
          border: 6px solid #e6e6e6;
          border-radius: 40px;
          padding: 32px 25px;
          box-sizing: border-box;
          font-size: 28px;
          color: #040000;
        }
        .restaurant_list {
          font-size: 24px;
          color: #040000;
          margin: 30px;
          .restaurant_item {
            margin-bottom: 20px;
            p {
              margin-right: 60px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
  .custom-title {
    span {
      font-size: 20px;
    }
  }
  .dropdown_wrap_container {
    padding: 0 30px;
    box-sizing: border-box;
    align-items: flex-start;
    .dropdown_list {
      flex: 1;
      font-size: 26px;
      color: #323233;
      .dropdown_item {
        height: 70px;
        border-bottom: 1px solid #ebedf0;
        &.active {
          color: #ee0a24;
        }
        .sitetype {
          font-size: 22px;
        }
        // &.place {
        //   opacity: 0;
        // }
      }
    }
  }

  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_popup_wrap {
      background: #ffffff;
      overflow-y: scroll;
      height: 84vh;
      .list {
        padding: 20px 10px;
        box-sizing: border-box;
        .item {
          // width: 660px;
          // min-height: 700px;

          // border: 6px solid #e6e6e6;
          // border-radius: 40px;
          margin: 0 auto 240px;
          padding: 52px 44px 0;
          box-sizing: border-box;
          font-size: 28px;
          color: #040000;
          .column {
            &.column_custom {
              margin-top: 35px;
              .custom_btn {
                margin: 0;
                &.disabled {
                  background: #9e9e9e;
                  color: #fff;
                }
                a {
                  color: #fff;
                }
              }
              &.flex-colc {
                align-items: flex-end;
                .custom_btn {
                  margin-bottom: 25px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }
          }
          .block_one {
            font-size: 30px;
            margin-bottom: 65px;
            .column {
              .label {
                width: 140px;
              }
              .con {
                color: #ff0000;
              }
            }
          }
          .block_two {
            margin-bottom: 99px;
          }
          .block_three {
            margin-bottom: 85px;
          }
          .btn {
            margin-bottom: 60px;
          }
          .column {
            align-items: flex-start;
            &:nth-child(2n) {
              margin: 26px 0;
            }
            .label {
              white-space: nowrap;
              width: 190px;
              flex-shrink: 0;
            }
            .con {
              word-wrap: break-word;
              flex-shrink: 0;
              width: 380px;
            }
          }
          .block {
            align-items: flex-end;
            .primary-button {
              height: 60px;
              line-height: 60px;
              margin-bottom: 25px;
              width: 280px;
              box-sizing: border-box;
              font-size: 16px;
              &:first-child {
                margin-top: 40px;
              }
            }
          }
          .reset_btn {
            margin-top: 180px;
          }
        }
      }
    }
  }
  .fixd_custom {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 210px;
    width: 360px;
    height: 70px;
    background: #096f70;
    border-radius: 45px;
    font-size: 30px;
    color: #fff;
    z-index: 1001;
    .iconfont {
      font-size: 36px;
    }
    .txt {
      span {
        font-size: 16px;
        margin-top: 5px;
      }
    }
  }

  /deep/ .van-popup.custom_my_popup {
    background: transparent;
  }
  .popup_container {
    position: relative;
    // height: 600px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .popup_wrap {
      width: 660px;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      background: #fff;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        margin-bottom: 40px;
        padding: 15px 20px;
        box-sizing: border-box;
        /deep/ .van-cell {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>